import { authenticatedFetch } from '../authenticatedFetch';
import { getEnvironmentUrls } from '../urls';

export function getEntityInfo() {
  const agentId = sessionStorage.getItem('agntId');
  const envUrls = getEnvironmentUrls();
  return authenticatedFetch(`/sub/${envUrls.apiUrl}/v1/entities/${agentId}`, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      return { status: response.status };
    }
  });
}
